import './styles.scss';

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';
import genericCollectionUtils from '@nhl/generic-collection-utils';
import { statFormatter, mathFormatter } from '@nhl/formatter-utilities';
import Leaders from '@nhl/nhl-react-ui/lib/Leaders';

import { leadersOperations } from '../../../redux/ducks/leaders';

import gameTypes from 'media-base-ui/utils/gameTypes';
import { componentSeasonSelectors } from 'media-base-ui/redux/ducks/componentSeason';
import ComponentSeasonIdentifiers from 'media-base-ui/utils/componentSeasonIdentifiers';

const PlayerLeaderboard = () => {
    const { season, gameType } = componentSeasonSelectors(ComponentSeasonIdentifiers.STATS);

    const isLoading = useSelector(({ leaders }) => genericCollectionUtils.orAllValuesOfObjectsByKey(leaders.loadingState, 'isLoading'));
    const leadersState = useSelector(({ leaders }) => leaders.leadersState);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(leadersOperations.fetchPlayerTotalsData(season, gameType));
        dispatch(leadersOperations.fetchGoalieTotalsData(season, gameType));
        dispatch(leadersOperations.setSelectedGameType(gameType));
    }, []);

    const setGameType = (gameType) => {

        if(leadersState.allPlayers[gameType] === undefined){
            dispatch(leadersOperations.fetchPlayerTotalsData(season, gameType));
        }

        if(leadersState.allGoalies[gameType] === undefined){
            dispatch(leadersOperations.fetchGoalieTotalsData(season, gameType));
        }

        dispatch(leadersOperations.setSelectedGameType(gameType));
    };

    const leagueAverage = (statType, gameType, skaterType, isStatTypeAnAverage = false) => {
        const values = leadersState[skaterType][gameType].map(player => player[statType]);
        const averageDisplayString = (string) => {
            return isStatTypeAnAverage ? string : `avg${string.charAt(0).toUpperCase() + string.slice(1)}`
        };
        return statFormatter.displayValueAs(averageDisplayString(statType))(mathFormatter.average(values));
    };

    const selectedGameType = leadersState.selectedGameType;

    const activeClassForGameType = (gameType) => {
        return selectedGameType === gameType ? 'active' : ''
    };

    return (
           <section>
                <div className="player-leaderboard-module-container">
                    <div>
                        <h3>
                            Player Leaderboard
                            {
                                gameType === gameTypes.PLAYOFFS
                                    ?   <div className="links leader-game-type-links">
                                            <button
                                                className={ activeClassForGameType(gameTypes.REGULAR_SEASON) }
                                                onClick={() => setGameType(gameTypes.REGULAR_SEASON)}>
                                                Regular Season
                                            </button>
                                            <button
                                                className={ activeClassForGameType(gameTypes.PLAYOFFS) }
                                                onClick={() => setGameType(gameTypes.PLAYOFFS)}>
                                                Playoffs
                                            </button>
                                        </div>
                                    :   null
                            }
                        </h3>
                    </div>

                    <LoadingDisplay isLoading={isLoading}>
                        { leadersState.allPlayers[selectedGameType] !== undefined && leadersState.allGoalies[selectedGameType] !== undefined
                            ?   <div className="leaders-container">
                                    <Leaders
                                        category={'points'}
                                        leaders={leadersState.pointsLeaders[selectedGameType]}
                                        statValues={leadersState.pointsLeaders[selectedGameType].map((player) =>
                                            statFormatter.displayValueAs('points')(player.points)
                                        )}
                                        gameType={selectedGameType}
                                        leagueAverage={leagueAverage('points', selectedGameType, 'allPlayers')}
                                    />
                                    <Leaders
                                        category={'goals'}
                                        leaders={leadersState.goalsLeaders[selectedGameType]}
                                        statValues={leadersState.goalsLeaders[selectedGameType].map((player) =>
                                            statFormatter.displayValueAs('goals')(player.goals)
                                        )}
                                        gameType={selectedGameType}
                                        leagueAverage={leagueAverage('goals', selectedGameType, 'allPlayers')}
                                    />
                                    <Leaders
                                        category={'wins'}
                                        leaders={leadersState.winsLeaders[selectedGameType]}
                                        statValues={leadersState.winsLeaders[selectedGameType].map((player) =>
                                            statFormatter.displayValueAs('wins')(player.wins)
                                        )}
                                        gameType={selectedGameType}
                                        leagueAverage={leagueAverage('wins', selectedGameType, 'allGoalies')}
                                    />
                                    <Leaders
                                        category={'goalsAgainstAverage'}
                                        leaders={leadersState.gaaLeaders[selectedGameType]}
                                        statValues={leadersState.gaaLeaders[selectedGameType].map((player) =>
                                            statFormatter.displayValueAs('goalsAgainstAverage')(player.goalsAgainstAverage, true)
                                        )}
                                        categoryOverride={'gaa'}
                                        gameType={selectedGameType}
                                        leagueAverage={leagueAverage('goalsAgainstAverage', selectedGameType, 'allGoalies', true)}
                                    />
                                </div>
                            :   null
                        }
                    </LoadingDisplay>
            </div>
            </section>

    );
};

export default PlayerLeaderboard;
